import React from 'react'
import Navbar from './Components/Navbar/Navbar'
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Hero from './Components/Home/Hero'
import Skills from './Components/Skills/Skills'
import About from './Components/About/About'
import Portfolio from './Components/Portfolio/Portfolio'
import Expirience from './Components/Expirience/Expirience';
function App() {
  return (
    <div>
      <Navbar />
      <BrowserRouter>
         <Routes>
         </Routes>
      </BrowserRouter>
      <Hero />
      <About />
      {/* <Portfolio /> */}
      <Expirience/>
    </div>
  )
}

export default App